export default "__VITE_ASSET__CgIN_0v7__"